import React, { useEffect, useState } from 'react';
import CandlestickChart from './CandlestickGraph';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import Skeleton from '../../../Shared/Skeleton';

const CandlestickSection = ({ filterdata, packType }) => {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [candleStickData, setCandlestickData] = useState({})
    const [sensorName, setSensorName] = useState("Sensor_1")

    useEffect(() => {
        let reqObj = {
            ...filterdata,
            sensorKey: `${packType}_${sensorName}`
        }

        fetchData({
            url: API_URL_MAIN + `battery_digital_twin/temp_candle_sticks`,
            body: { filterdata: reqObj },
        },
            (data) => {
                let candleData = { ...data }
                if (data) {
                    candleData.minValue = data?.summary?.overall_min
                    candleData.minDate = data?.summary?.overall_min_date
                    candleData.maxValue = data?.summary?.overall_max
                    candleData.maxDate = data?.summary?.overall_max_date
                    candleData.meanValue = data?.summary?.mean_of_means
                }
                setCandlestickData(candleData)
            });
    }, [filterdata, packType, sensorName])

    return (
        <div className='row card'>
            <div className=" col-3 align-content-center text-center mb-4 mt-2">
                <select className="form-select form-select-sm" aria-label="Default select example" value={sensorName} onChange={(e) => setSensorName(e.target.value)} >
                    <option value="Sensor_1">Sensor_1</option>
                    <option value="Sensor_2">Sensor_2</option>
                    <option value="Sensor_3">Sensor_3</option>
                    <option value="Sensor_4">Sensor_4</option>
                    <option value="Sensor_5">Sensor_5</option>
                    <option value="Sensor_6">Sensor_6</option>
                    <option value="Sensor_7">Sensor_7</option>
                    <option value="Sensor_8">Sensor_8</option>
                    <option value="Sensor_9">Sensor_9</option>
                    <option value="Sensor_10">Sensor_10</option>
                    <option value="Sensor_11">Sensor_11</option>
                    <option value="Sensor_12">Sensor_12</option>
                    <option value="Coolant_Temp_In">Coolant_Temp_In</option>
                    <option value="Coolant_Temp_Out">Coolant_Temp_Out</option>
                    <option value="Coolant_In_Out_diff">Coolant_In_Out_diff</option>
                </select>
            </div>

            <CandlestickChart inputData={candleStickData} isLoading={isLoading} />
            <div className='d-flex flex-column align-items-start mb-2 col-12 col-lg-6'>
                {
                    sensorName.includes("Sensor") ?
                        <>
                            {
                                isLoading ?
                                    <>
                                        <Skeleton className='ms-4 my-1' width="90%" height="10px" />
                                        <Skeleton className='ms-4 my-1' width="90%" height="10px" />
                                        <Skeleton className='ms-4 my-1' width="90%" height="10px" />
                                    </>
                                    : <>
                                        <small className='ms-4 text-secondary'>1.Minimum <b>{sensorName}</b> temperature recorded in the selected date range is <b>{candleStickData?.minValue}°C</b> on <b>{candleStickData?.minDate}</b>.</small>
                                        <small className='ms-4 text-secondary'>2.Maximum <b>{sensorName}</b> temperature recorded in the selected date range is <b>{candleStickData?.maxValue}°C</b> on <b>{candleStickData?.maxDate}</b>.​</small>
                                        <small className='ms-4 text-secondary'>3.Mean <b>{sensorName}</b> temperature recorded in the selected date range is <b>{candleStickData?.meanValue}°C</b>.​</small>
                                    </>
                            }
                        </>
                        :
                        <>
                            {
                                isLoading ?
                                    <Skeleton className='ms-4 my-1' width="90%" height="10px" />
                                    : <small className='ms-4 text-secondary'>1.<b>{sensorName}:</b> Mean temperature recorded in the selected date range is <b>{candleStickData?.meanValue}°C</b>.</small>
                            }
                        </>
                }
            </div>
        </div>
    );
}

export default CandlestickSection;
